import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../contexts/PermissionContext';
import { getRoleDisplayName } from '../../utils/rolePermissions';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { hasPageAccess, permissionsLoaded, roleInfo } = usePermissions();
  const location = useLocation();

  // Loading durumunda spinner göster
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '16px',
        fontSize: window.innerWidth <= 768 ? '16px' : '14px'
      }}>
        <div>Yükleniyor...</div>
      </div>
    );
  }

  // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Permissions henüz yüklenmediyse loading göster
  if (!permissionsLoaded) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        fontSize: '14px',
        color: '#999'
      }}>
        <div>İzinler yükleniyor...</div>
      </div>
    );
  }

  // Sayfa erişim kontrolü (API'den gelen izinlerle)
  const hasAccess = hasPageAccess(location.pathname);

  if (!hasAccess) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Bu sayfaya erişim yetkiniz bulunmamaktadır."
        extra={
          <div>
            <p>
              Mevcut rolünüz: <strong>{getRoleDisplayName(roleInfo || user.role)}</strong>
            </p>
            <Button
              type="primary"
              onClick={() => window.history.back()}
              style={{
                height: window.innerWidth <= 768 ? '44px' : '32px',
                fontSize: window.innerWidth <= 768 ? '16px' : '14px'
              }}
            >
              Geri Dön
            </Button>
          </div>
        }
      />
    );
  }

  return children;
};

export default ProtectedRoute;
